<template>
  <div class="article" @click="articleClicked">
    <div class="image">
      <img :src="newsItem.bannerImage?.url" alt="" v-if="newsItem.bannerImage">
    </div>
    <div class="info">
      <p class="dateline">{{ formatDayDateMonthYear(newsItem.publicationStatus.lastPublicationDate) }}</p>
      <p class="title">{{ newsItem.title }}</p>
    </div>
  </div>
</template>

<script>
import DateFormatter from "@/mixins/DateFormatter";

export default {
  name: "ActivitySmall",
  computed: {},
  mixins: [ DateFormatter ],
  props: {
    newsItem: Object,
  },
  data()
  {
    return {}
  },
  methods: {
    articleClicked()
    {
      this.$router.push({
        name: 'article-detailed', params: {
          id: this.newsItem.id
        }
      });
    }
  },
  created()
  {

  }
}
</script>

<style lang="scss" scoped>
.article
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-bottom: 0.66rem;
  cursor: pointer;
  height: 100px;
  display: flex;
  //align-items: center;

  .image
  {
    flex: 3 3;
    display: flex;

    img
    {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px 0px 0px 5px;

    }
  }

  .info
  {
    padding: 10px;
    flex: 6 6;

    .dateline
    {
      font-size: $body-text-size;
      font-style: italic;
      color: $font-grey;
      margin-bottom: 3px;
    }

    .title
    {
      font-size: $body-text-size;
      font-weight: bold;

      //clamp text to 2 lines and add ellipsis
      display: block; /* Fallback for non-webkit */
      display: -webkit-box;
      max-width: 400px;
      height: $body-text-size*2*1.5; /* Fallback for non-webkit */
      margin: 0 auto;
      line-height: 20px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>